import React, { useMemo, useState, useEffect, useCallback } from "react";
import Customtable from "../helper/Customtable";
import Swal from "sweetalert2";
import { post } from "../helper/api_helper";

const CfsWiseArrivalStatus = () => {
  const [groupedData, setGroupedData] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [loading, setLoading] = useState(false);

  // Filter state 
  const [CSFLocationOptions, setCFSLocationOptions] = useState([]);
  const [cfsId, setCfsId] = useState("");

  // ------------------------------
  // Alert Helper
  // ------------------------------
  const showAlert = useCallback((icon, title, text, timer = 2000) => {
    Swal.fire({
      icon,
      title,
      text: text || "Something went wrong.",
      timer,
      showConfirmButton: false,
    });
  }, []);

  // ------------------------------
  // Fetch Data
  // ------------------------------
  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const payload = {};
      if (cfsId) payload.cfs_id = cfsId;

      const response = await post("/reports/cfs_wise_arrival_status/list", payload);
      if (response.status === 200) {
        setGroupedData(response.data || []);
      } else {
        showAlert("error", response.status, response.message);
      }
    } catch (err) {
      showAlert("error", "Unexpected Error", err.message);
    } finally {
      setLoading(false);
    }
  }, [showAlert, cfsId]);
  const fetchCFSLocationData = useCallback(async () => {
    try { const r = await post("/masters/Cfs_location/list"); if (r.status === 200) setCFSLocationOptions([{ value: "", label: "Select CFS Location" }, ...r.data.map(i => ({ value: i.cfs_location_id, label: i.cfs_code }))]); } catch { }
  }, []);
  useEffect(() => {
    fetchData();
    fetchCFSLocationData();
  }, [fetchData, fetchCFSLocationData]);

  // ------------------------------
  // Table Columns
  // ------------------------------
  const columns = useMemo(
    () => [
      { header: "S.No", accessorKey: "si_no", enableColumnFilter: false, enableSorting: false },
      { header: "Job No", accessorKey: "job_no" },
      { header: "Consignee", accessorKey: "consignee" },
      { header: "Shipper", accessorKey: "shipper" },
      { header: "POL", accessorKey: "pol" },
      { header: "Desc", accessorKey: "description" },
      { header: "Liner", accessorKey: "liner" },
      { header: "BL No", accessorKey: "bl_number" },
      { header: "TC", accessorKey: "no_of_containers", isTotal: true },
      { header: "20'", accessorKey: "count_20ft" },
      { header: "40'", accessorKey: "count_40ft" },
      { header: "LCL", accessorKey: "count_lcl" },
      { header: "Arrived", accessorKey: "arrived" },
      { header: "Detention Date", accessorKey: "detention_upto" },
      { header: "STR Free", accessorKey: "storage_date" },
      { header: "Weight", accessorKey: "weight", isTotal: true },
      { header: "BE No", accessorKey: "be_number" },
      { header: "BE Date", accessorKey: "be_date" },
    ],
    []
  );

  return (
    <>
      <div className="page-header d-flex justify-content-between align-items-center">
        <div>
          <div className="page-header-title">CFS Wise Arrival Status</div>
        </div>
      </div>

      {/* Filters */}
      <div className="card mt-3">
        <div className="card-body">
          <div className="row g-3 align-items-end">
            <div className="col-md-3">
              <label className="form-label">CFS Code</label>
              <select
                className="form-control"
                value={cfsId}
                onChange={(e) => setCfsId(e.target.value)}
              >
                <option value="">Select CFS Code</option>
                {CSFLocationOptions.map((opt) => (
                  <option key={opt.value} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-md-2">
              <button className="btn btn-primary w-100" onClick={fetchData} disabled={loading}>
                {loading ? "Loading..." : "Search"}
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Render one card per CFS group */}
      {groupedData.length > 0 ? (
        groupedData.map((group, idx) => (
          <div className="card basic-data-table mt-3" key={idx}>
            <div className="card-header d-flex justify-content-between align-items-center">
              <h5 className="card-title mb-0">
                CFS: <span className="text-primary">{group.cfs_name || "—"}</span>
              </h5>
              <span className="badge bg-info">{group.records?.length || 0} Jobs</span>
            </div>
            <div className="card-body">
              <Customtable
                table_title={`CFS Arrival - ${group.cfs_name}`}
                columns={columns}
                data={group.records || []}
                isGlobalFilter={true}
                isPagination={true}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                isExportButton={true}
              />
            </div>
          </div>
        ))
      ) : (
        !loading && (
          <div className="card mt-3">
            <div className="card-body text-center text-muted py-4">
              No data found. Please adjust filters and search again.
            </div>
          </div>
        )
      )}
    </>
  );
};

export default CfsWiseArrivalStatus;
